const links = document.querySelectorAll('.c-scroll-link');
for (let i = 0; i < links.length; i++) {
  links[i].addEventListener('click', (e) => {
    e.preventDefault();
    const targetId = e.target.hash;
    const targetElement = document.querySelector(decodeURI(targetId));
    const elementY = targetElement.getBoundingClientRect().top;
    const scrollY = window.scrollY;
    const offset = 0; // スクロール位置をずらす（px）
    window.scrollTo({
      top: scrollY + elementY - offset,
      behavior: 'smooth'
    });
  });
}